<template>
    <fragment>
        <out-put-page
            title="Étude technique"
            sectionRef="moyen_dexploitation"
            v-on:page-updated="handleAfterRender"
        >
            <section v-if="moyensFonciersEtImmeubles.length > 0">
                <h3>Moyens Fonciers et immeubles</h3>
                <land-and-building-cards
                    :buildings="moyensFonciersEtImmeubles"
                />
            </section>
        </out-put-page>
    </fragment>
</template>

<script>
import Vue from "vue";
import SectionTitleTable from "../components/SectionTitleTable";
import OutPutPage from "../components/OutPutPage";
import LandAndBuildingCards from "../components/LandAndBuildingCards";
import * as utils from "@/utils.js";
import isEmpty from "lodash/isEmpty";

const pageContentHeight = 1500;
const OutPageComponent = Vue.extend(OutPutPage);
const TableComponent = Vue.extend(SectionTitleTable);
export default {
    components: {
        // eslint-disable-next-line
        SectionTitleTable,
        OutPutPage,
        LandAndBuildingCards
    },
    props: {
        itmo: {
            type: Array,
            required: true
        },
        moyensFonciersEtImmeubles: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            data: [],
            renderTrigger: ""
        };
    },

    mounted() {
        const itmoTableData = this.initTableData();
        const $vm = this;
        this.data.push({
            data: itmoTableData,
            prevData: this.data[0],
            firstItemLock: true,
            seed(data = this.data[0]) {
                if (this.isEmpty()) {
                    $vm.data.shift();
                    return;
                }
                $vm.$nextTick(() => {
                    this.componentInstance.$props.tables.data[0].content.push(
                        data
                    );
                    this.currentPage.renderTrigger = utils.generateUID();
                });
                this.prevData = data;
                this.data.shift();
                if (this.isEmpty()) {
                    $vm.data.shift();
                }
            },
            isEmpty() {
                return isEmpty(this.data);
            },
            pop() {
                this.componentInstance.$props.tables.data[0].content.pop();
                this.data = [this.prevData, ...this.data];
            },
            componentInstance: "",
            initComponent() {
                this.componentInstance = new TableComponent({
                    propsData: {
                        tables: {
                            headers: [
                                { title: "Désignation", type: "String" },
                                { title: "Nombres", type: "String" },
                                { title: "Caractéristiques", type: "String" },
                                { title: "Prix(HT)", type: "Currency" },
                                { title: "Fournisseur", type: "String" },
                                { title: "Origine", type: "String" }
                            ],
                            data: [
                                {
                                    title:
                                        "Installation technique et Matériels et outillage ",
                                    content: []
                                }
                            ]
                        }
                    }
                });
            },
            newPage() {
                const newPage = new OutPageComponent({
                    propsData: {
                        title: "Étude technique",
                        sectionRef: "moyen_dexploitation"
                    }
                });
                newPage.$mount();
                newPage.$on("page-updated", $vm.handleAfterRender);
                $vm.$children[
                    $vm.$children.length - 1
                ].$refs.moyen_dexploitation.after(newPage.$el);
                $vm.$children.push(newPage);

                this.currentPage = $vm.$children[$vm.$children.length - 1];
            },
            currentPage: $vm.$children[$vm.$children.length - 1],
            initSection() {
                const PartnersSection = document.createElement("section");
                const PartnersSectionTitle = document.createElement("h3");
                PartnersSectionTitle.innerHTML = "Moyens d'exploitation";
                PartnersSection.appendChild(PartnersSectionTitle);
                this.componentInstance.$mount();
                PartnersSection.appendChild(this.componentInstance.$el);
                this.currentPage.$refs.content.appendChild(PartnersSection);
            }
        });

        this.handleAfterRender();
    },
    methods: {
        handleAfterRender(contentHeight) {
            for (const instance of this.data) {
                if (instance.firstItemLock && instance.data.length > 0) {
                    instance.firstItemLock = false;
                    instance.initComponent();
                    if (pageContentHeight - contentHeight < 300)
                        instance.newPage();
                    instance.initSection();
                }
                if (contentHeight >= pageContentHeight) {
                    instance.pop();
                    instance.initComponent();
                    instance.newPage();
                    instance.initSection();
                    instance.seed(instance.prevData);
                } else {
                    instance.seed();
                }
                break;
            }
        },
        initTableData() {
            const keysOrder = [
                "designation",
                "nombre",
                "caracteristique",
                "prix",
                "nomFournisseur",
                "origine"
            ];
            const itmo = [];

            this.itmo.forEach(item => {
                itmo.push(
                    keysOrder.map(elem => {
                        return item[`${elem}`];
                    })
                );
            });
            return itmo;
        }
    }
};
</script>

<style></style>
